<template>
  <div>
    <a-spin :spinning="loading">

      <a-divider orientation="left">营收汇总报表</a-divider>
      <a-form ref="reportForm" name="reportForm" :model="reportFormModelRef" :label-col="{ span: 7 }" :wrapper-col="{ span: 10 }"
              @finish="onReportFormSubmit">

        <a-form-item label="日期" name="date" :rules="[{ required: true, message: '必填项不允许为空' }]">
          <a-date-picker v-model:value="reportFormModelRef.date" style="width: 300px" :disabled-date="disabledDate"/>
        </a-form-item>

        <div style="text-align: center;margin-bottom: 20px">
          <a-button type="primary" html-type="submit">更新报表</a-button>
        </div>

      </a-form>
    </a-spin>
  </div>
</template>

<script>

  import { revenueSatementSave } from "@/service/modules/system";

  export default {
    data() {
      return {
        loading: false,
        organizationList: [],
        cinemaList: [],
        cardAllList: [],
        reportFormModelRef: {
          date: ''
        },
        jsonData: {}
      }
    },
    created() {
    },
    computed: {

    },
    methods: {
      disabledDate(current) {
        return current && current >= this.moment().endOf('day');
      },
      async onReportFormSubmit() {
        this.loading = true;
        this.$refs.reportForm.validateFields().then(async () => {
          const times = this.reportFormModelRef.date.diff(this.moment(), 'days');
          console.log(times)
          await revenueSatementSave({times});
          this.$message.success('更新成功');
          this.loading = false;
        }).catch(e=>{
          this.loading = false;
        })

      },
    }
  }
</script>

<style scoped>

</style>
